import { ValueObject } from '@/domain/valueObject';

/**
 * プロパティ
 */
export interface ContentAttachmentProps {
  /** コンテント */
  content: string,
  /** 名前 */
  name: string,
}

export class ContentAttachment extends ValueObject<ContentAttachmentProps> {
  /**
   * 作成
   * @param props 値
   * @returns 値
   */
  static create(props: ContentAttachmentProps): ContentAttachment {
    return new ContentAttachment(props);
  }

  /**
   * コンテント
   */
  get content(): string {
    return this.val.content;
  }

  /**
   * 名前
   */
  get name(): string {
    return this.val.name;
  }
}
